import ConfirmRequestActive from '../Assets/Steps/ConfirmRequestActive.svg';
import ConfirmRequestInactive from '../Assets/Steps/ConfirmRequestInactive.svg';
import CourierInactive from '../Assets/Steps/CourierInactive.svg';
import CourierActive from '../Assets/Steps/CourierActive.svg';
import CustomerValidatingActive from '../Assets/Steps/CustomerValidatingActive.svg';
import CustomerValidatingInactive from '../Assets/Steps/CustomerValidatingInactive.svg';
import OrderCompletedActive from '../Assets/Steps/OrderCompletedActive.svg';
import OrderCompletedInactive from '../Assets/Steps/OrderCompletedInactive.svg';
import RequestInformationActive from '../Assets/Steps/RequestInformationActive.svg';
import TrackCourierActive from '../Assets/Steps/TrackCourierActive.svg';
import TrackCourierInactive from '../Assets/Steps/TrackCourierInactive.svg';
import WarehouseValidatingActive from '../Assets/Steps/WarehouseValidatingActive.svg';
import WarehouseValidatingInactive from '../Assets/Steps/WarehouseValidatingInactive.svg';

const StepIcon = {
  ConfirmRequestActive,
  ConfirmRequestInactive,
  CourierActive,
  CourierInactive,
  CustomerValidatingActive,
  CustomerValidatingInactive,
  OrderCompletedActive,
  OrderCompletedInactive,
  RequestInformationActive,
  TrackCourierActive,
  TrackCourierInactive,
  WarehouseValidatingActive,
  WarehouseValidatingInactive,
};

export default StepIcon;
